// 发票
<template>
  <div class="Invoice defBorderRadius">
    <ul class="menu defBorderRadius">
      <router-link
        v-for="item in menuList"
        class="item pointer"
        active-class="def-active"
        tag="li"
        :key="item.name"
        :to="`${item.name}`"
      >
        {{ item.title }}
        <div class="line"></div>
      </router-link>
    </ul>
    <router-view />
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      menuList: [
        {
          title: "申请发票",
          name: "list",
        },
        {
          title: "开票记录",
          name: "my",
        },
      ],
    };
  },
  created() {},
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
.Invoice {
  background: #fff;
  .menu {
    background: #fff;
    height: 60px;
    padding: 0 20px;
    flex: 1;
    display: flex;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 60px;
    position: relative;
    .item {
      margin-right: 40px;
      position: relative;
    }

    .def-active {
      color: #0062ff !important;

      .line {
        display: block;
        background: #0062ff;
      }
    }

    .line {
      width: 16px;
      height: 2px;
      border-radius: 8px;

      position: absolute;
      bottom: 10px;
      left: 0;
      right: 0;
      margin: auto;
      display: none;
    }
  }
}
</style>
